export const Employee = {
    id: '',
    employeeId: '',
    memberId: '',
    email: '',
    firstName: '',
    lastName: '',
    departmentId: '',
    departmentName: '',
}